var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6: true, browser:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['svc_versions', '/util/etask.js', '/util/zerr.js', 'virt_jquery_all', '/util/escape.js', '/util/user_agent.js', '/util/version_util.js', '/util/date.js', '/util/url.js', 'hola_opt', '/www/hola/pub/app_checker.js', '/util/util.js', 'cookie', '/www/hola/pub/site_load.js', 'pub_config', '/svc/account/pub/membership.js', '/util/rand.js', '/util/storage.js', '/www/hola/pub/experiment_init', '/util/fetch.js', 'loadTimeData', '/www/hola/pub/client_hints_global.ts'], function (versions, etask, zerr, $, zescape, user_agent, version_util, date, zurl, hopt, app_checker, zutil, cookie, site_load, config, membership, rand, storage, experiment_init, {
  fetch
}, load_time_data, {
  guess_os_and_version
}) {
  experiment_init = experiment_init.default;
  var data_from_browser = load_time_data.data;
  if (!is_node) {
    etask.set_zerr(zerr);
    zerr.set_exception_handler('www', function (id, info, err) {
      var bt = zerr.e2s(err);
      E.perr({
        id: id,
        info: info,
        bt
      });
      zerr('exception ' + id + ' ' + (err.stack || err));
    });
    setTimeout(function () {
      var s = document.getElementById('pap_x2s6df8d');
      if (!s || !s.hasAttribute('loaded')) {
        var info = {
          src: s && s.getAttribute('src'),
          err: window.pap_load_err
        };
        E.perr({
          id: 'www_js_load_failed_pap',
          info: info
        });
      }
    }, 10000);
  }
  var url_o = zurl.parse(location.href);
  var qs_o = zurl.qs_parse((url_o.search || '').substr(1), {
    safe: true
  });
  var b = user_agent.guess_browser();
  var sys = user_agent.guess();
  var E = {
    download_url: {
      firefox_signed: config.cdn_url + '/static/hola_firefox_ext_signed0_' + versions.firefox_signed0 + '_www.xpi',
      chrome_manual: config.cdn_url + '/static/hola_chrome_ext_' + '1.8.327.crx',
      chrome_zip_static: config.cdn_url + '/static/hola_chrome_ext_' + '1.8.327.zip',
      opera_manual: config.cdn_url + '/static/hola_opera_ext_' + versions.opera + '.crx'
    },
    sys,
    session_sync_logs: []
  };
  E.get_exe_link = site_load.get_exe_link;
  E.get_exe_filename = site_load.get_exe_filename;
  if (b.browser == 'firefox' && version_util.cmp(b.version, '52') < 0) {
    E.download_url.firefox_signed = config.cdn_url + '/static/hola_firefox_ext_signed0_' + versions.firefox_bootstrap_last + '_www.xpi';
  } else if (b.browser == 'firefox' && version_util.cmp(b.version, '57') >= 0) {
    E.download_url.firefox_signed = '//addons.mozilla.org/firefox/downloads' + '/latest/hola-free-vpn-proxy-unblocker/';
  }
  E.get_cookie_description = () => {
    return hopt.cookie_value_parsed || {};
  };
  var on_pap_load = function on_pap_load() {
    try {
      update_pap_cookies();
    } catch (e) {
      E.perr({
        id: 'www_pap_change_err',
        info: {
          error: zerr.e2s(e)
        }
      });
    }
  };
  var is_private_mode = () => etask(function* () {
    if (b.browser == 'chrome' || b.browser == 'opera') {
      if (!navigator.storage) return true;
      var data = yield navigator.storage.estimate();
      // private mode quota is less than 10GB
      return data.quota < 10000000000;
    } else if (b.browser == 'safari') {
      try {
        if (localStorage.length) return false;
        localStorage.setItem('check_if_private', '0');
        localStorage.removeItem('check_if_private');
        return false;
      } catch (e) {
        return navigator.cookieEnabled;
      }
    } else if (b.browser == 'edge' || b.browser == 'firefox') return !navigator.storage;
    return false;
  });
  E.initial_props = {};
  E.utils_props = {};
  E.init = function (props, postpone_detection, utils_props) {
    cookie.defaults = {
      secure: true
    };
    console.info = function () {};
    app_checker.set_perr_fn(E.perr);
    E.initial_props = props;
    Object.assign(E.utils_props, utils_props || {});
    experiment_init.init_ui_tests(props, undefined, E.perr);
    E._is_installed = {};
    if (window.pap_ready) on_pap_load();else {
      window.on_pap_ready = function () {
        on_pap_load();
      };
    }
    try {
      set_mkt_cookies(E.marketing_obj);
    } catch (e) {}
    if (E.utils_props.no_detection) return;
    // XXX sergeir: this task takes ~2s, run it in parallel
    var detection_fn = () => etask(function* () {
      E._is_installed = yield etask.all({
        ext: app_checker.is_ext(),
        svc: app_checker.is_svc()
      });
      site_load._is_installed = E._is_installed;
      if (E._is_installed.svc) localStorage.app_installed = true;else localStorage.app_installed = false;
    });
    if (postpone_detection) setTimeout(() => detection_fn(), 2000);else detection_fn();
    return etask(function* () {
      E._is_private = yield is_private_mode();
    });
  };
  E.post_msg = function (msg) {
    top.postMessage(msg, '*');
  };
  E.msg_post_recv = function (opt) {
    var msg = opt.msg,
      on_msg;
    return etask([function () {
      on_msg = function (e) {
        if (e.source != top || e.data.src == msg.src || e.data.id != msg.id) return;
        this.continue(e.data);
      }.bind(this);
      try {
        // will init exception on cross origin frame access
        top.addEventListener('message', on_msg);
      } catch (e) {
        this.continue();
        return;
      }
      top.postMessage(msg, '*');
      return this.wait(opt.timeout || 5000);
    }, function finally$() {
      // will init exception on cross origin frame access
      try {
        top.removeEventListener('message', on_msg);
      } catch (e) {}
    }]);
  };
  E.ajax = function (opt) {
    return etask([function () {
      opt = opt || {};
      this.alarm(opt.timeout || 20000, {
        throw: new Error('timeout')
      });
      return $.ajax(opt);
    }]);
  };

  /**
   * @deprecated Use www/hola/pub/app_checker.js methods instead.
   */
  E.check_ext = function (opt) {
    opt = opt || {};
    return E.msg_post_recv({
      timeout: opt.timeout || 2000,
      msg: {
        src: 'hola_ccgi',
        id: 'callback'
      }
    });
  };
  E.is_plugin = function (exe) {
    return /\bhola_plugin/.test(exe);
  };
  E.call_on_ext = function (cb) {
    return etask.for(null, function () {
      return etask.sleep(1000);
    }, [function try_catch$loop() {
      return E.check_ext();
    }, function (e) {
      if (this.error || !e || !e.data || !e.data.mode) return;
      cb();
      return this.break();
    }]);
  };
  E.alert = function (text) {
    $('.alert').text(text).addClass('in');
    setTimeout(function () {
      $('.alert').removeClass('in');
    }, 10000);
  };
  E.set_cookie = function (name, val, exp) {
    cookie.set(name, val, {
      domain: `.${location.host}`,
      path: '/',
      expires: date.add(date(), exp || {
        hour: 1
      })
    });
  };
  E.remove_cookie = function (name) {
    cookie.remove(name, {
      domain: `.${location.host}`,
      path: '/'
    });
  };
  var spa_time_start = 0;
  var block_visit_send = false;
  E.before_spa = function () {
    spa_time_start = Date.now();
    block_visit_send = false;
    window.reload_on_chunk_error = true;
  };
  E.get_uits = function (perr_id) {
    if (!perr_id) perr_id = '';
    var doc_ts = 0;
    var is_visit_perr = /www_.*_visit$/.test(perr_id);
    if (is_visit_perr && block_visit_send) return {
      time: 0
    };
    if (is_visit_perr) block_visit_send = true;
    var time = 0;
    if (spa_time_start) time = Date.now() - spa_time_start;else {
      try {
        time = Math.round(performance.now());
      } catch (e) {}
      // XXX dmitriiz: for some reason performance get 0, let's cal
      if (is_visit_perr && !time) time = Date.now() - window._the_first_js_data;
      if (is_visit_perr) {
        try {
          var url = performance.getEntries().find(entry => entry.initiatorType == 'navigation');
          doc_ts = url && Math.round(url.responseEnd);
        } catch (e) {}
      }
    }
    return {
      time,
      spa: !!spa_time_start,
      doc_ts
    };
  };
  var setup_ym_params = false;
  function build_info(opt, ext) {
    var active_test = E.get_active_tests();
    var build_additional = {};
    var ymetrika_data = {};
    active_test.forEach(t => {
      build_additional[`test_${t.id}`] = t.value;
      ymetrika_data[`test_${t.id}`] = t.value ? 1 : 0;
    });
    var tests_from_browser_qs = {};
    try {
      tests_from_browser_qs = JSON.parse(decodeURIComponent(qs_o.browser_experiments));
    } catch (e) {}
    var tests_from_browser_data = {};
    try {
      tests_from_browser_data = JSON.parse(decodeURIComponent(data_from_browser.browser_experiment));
    } catch (e) {}
    if (qs_o && qs_o.ref) {
      qs_o.ref.split('test_').filter(el => /_on|_off/.test(el)).map(el => {
        var on = !!/_on/.test(el);
        var name = on ? el.split('_on')[0] : el.split('_off')[0];
        tests_from_browser_qs[`test_${name}`] = on ? 'ON' : 'OFF';
      });
    }
    Object.keys(tests_from_browser_qs).concat(Object.keys(tests_from_browser_data)).forEach(t => {
      var val = tests_from_browser_qs[t] || tests_from_browser_data[t];
      build_additional[`${t}`] = val == 'ON';
      ymetrika_data[`${t}`] = val == 'ON' ? 1 : 0;
    });
    try {
      var svc_info = app_checker.get('svc_info') || {};
      if (svc_info.ab_tests) {
        svc_info.ab_tests.forEach(t => {
          var on_ = t.split('_on');
          var off_ = t.split('_off');
          if (on_[0] && !on_[1]) build_additional[`${on_[0]}`] = true;
          if (off_[0] && !off_[1]) build_additional[`${off_[0]}`] = false;
        });
      }
    } catch (e) {}
    if (window && window.ym && !setup_ym_params) {
      window.ym(hopt.www_hola.ymetrika_id, 'userParams', ymetrika_data);
      setup_ym_params = true;
    }
    var timing = E.get_uits(opt.id);
    if (timing.time) {
      build_additional.uits = timing.time;
      build_additional.spa = timing.spa;
    }
    if (window._reviving_timeout) build_additional.reviving_timeout = window._reviving_timeout;
    if (timing.doc_ts) build_additional.doc_ts = timing.doc_ts;
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      build_additional.effective_type = connection.effectiveType;
      build_additional.downlink = connection.downlink;
    }
    if (window && window.innerWidth) {
      var width = window.innerWidth;
      build_additional.screen = width >= 1440 ? 'xl' : width >= 1200 ? 'lg' : width >= 1024 ? 'md' : width >= 992 ? 'sm' : width >= 768 ? 'xs' : 'xxs';
      build_additional.screen_width = width;
    }
    if (window && window.innerHeight) build_additional.screen_height = window.innerHeight;
    if (window.last_global_theme_selected) build_additional.theme_name = window.last_global_theme_selected;
    var g_obj = guess_os_and_version();
    var user_info = user_cache && user_cache.user || E.initial_props.user;
    var hola_uid = user_info && user_info.hola_uid || opt.info && opt.info.email || '';
    var is_hola = hola_uid.indexOf('hola.org') > -1 || hola_uid.indexOf('brightdata') > -1;
    var memder_info = mship_cache || E.initial_props.member;
    var is_plus = membership.is_active(memder_info);
    var info = Object.assign({
      os: g_obj.os,
      os_version: g_obj.version,
      platform: navigator.platform,
      zua: navigator.userAgent,
      location_href: location.href,
      referrer: document.referrer,
      h_visitor_id: cookie.get('h_visitor_id') || hopt.h_visitor_id,
      www_visitor_id: cookie.get('h_visitor_id') || hopt.h_visitor_id,
      visitor_id: cookie.get('holapap_visitor_id'),
      a_aid: cookie.get('hola_a_aid'),
      a_bid: cookie.get('hola_a_bid'),
      a_cid: cookie.get('hola_a_cid'),
      aff_subid: cookie.get('holapap_aff_subid'),
      aff_subid2: cookie.get('holapap_aff_subid2'),
      aff_subid3: cookie.get('holapap_aff_subid3'),
      utm_medium: cookie.get('hola_utm_medium'),
      utm_source: cookie.get('hola_utm_source'),
      utm_campaign: cookie.get('hola_utm_campaign'),
      utm_content: cookie.get('hola_utm_content'),
      utm_term: cookie.get('hola_utm_term'),
      utm_match: cookie.get('hola_utm_match'),
      cio_medium: cookie.get('hola_cio_medium'),
      cio_source: cookie.get('hola_cio_source'),
      cio_campaign: cookie.get('hola_cio_campaign'),
      ref: cookie.get('orig_ref'),
      gclid: cookie.get('hola_gclid'),
      gbraid: cookie.get('hola_gbraid'),
      wbraid: cookie.get('hola_wbraid'),
      c_browser: cookie.get('c_browser') || hopt.c_browser,
      c_vpn: cookie.get('c_vpn') || hopt.c_vpn,
      private_mode: +E._is_private,
      www_version: hopt.version,
      is_premium: is_plus,
      logged: !!user_info,
      user_type: is_hola ? 1 : 2,
      install_ms: ext && ext.build_info && ext.build_info.install_ms,
      has_svc: localStorage.getItem('app_installed'),
      has_ext: !!(ext && ext.build_info)
    }, opt.build || {}, build_additional);
    zutil.if_set(opt.hola_uid, info, 'hola_uid');
    var s = '';
    for (var f in info) {
      if (/^test_/.test(f) || info[f]) s += (s && '\n') + f + ': ' + info[f];
    }
    return s;
  }
  var no_log = false;
  E.no_log = function () {
    return no_log;
  };
  E.no_log_perr = function (id) {
    return no_log && !E.no_log_perrs[id];
  };
  E.invalidate_no_log = function (is_plus) {
    no_log = is_plus && hopt.www_hola && hopt.www_hola.no_log_for_plus;
  };
  E.no_log_perrs = zutil.bool_lookup(hopt && hopt.www_hola && hopt.www_hola.no_log_perrs || []);
  function get_tid() {
    if (!E.get_cookie_description().pers) return '';
    var tid = cookie.get('tid');
    if (!tid) {
      tid = Date.now().toString(36) + '.' + rand.basic_u31(rand.rand_int32()).toString(36);
      cookie.set('tid', tid);
    }
    return tid;
  }
  E.get_browser = function (b_) {
    b_ = b_ || user_agent.guess_browser();
    return b_.opera ? 'opera' : b_.hola_browser ? 'hola' : b_.edge ? 'edge' : b_.browser;
  };
  var hdls = [];
  E.add_perr_hdl = function (fn) {
    hdls.push(fn);
  };
  var perr_url = config.perr_url || 'perr.hola.org';
  // XXX arik: need to use zerr.install_perr? reuse be.perr?
  /**
   * @param {(object|string)} [opt.info] Optional info about event. 'ext' and
   * 'svc' will be added to this object to show whether product is installed.
   */
  E.perr = function (opt) {
    if (E.no_log_perr(opt.id)) return;
    if (opt.id && opt.id.toLowerCase) opt.id = opt.id.toLowerCase();
    hdls.forEach(fn => fn(opt));
    if (opt.cancel_perr) return;
    var ext = config.get_hola_extension_info() || {},
      data = {},
      qs = {};
    qs.cid = opt.cid || ext.cid;
    // loadTimeData.data.uuid
    if (data_from_browser && data_from_browser.uuid) qs.uuid = data_from_browser.uuid;else {
      qs.uuid = opt.uuid || (storage.get('dont_use_ext_uuid') ? null : ext.uuid) || qs_o.uuid;
    }
    if (data_from_browser && data_from_browser.appid) qs.appid = data_from_browser.appid;else qs.appid = opt.appid || qs_o.appid;
    if (data_from_browser && data_from_browser.campaign) qs.campaign = data_from_browser.campaign;else qs.campaign = opt.campaign || qs_o.campaign;
    qs.tid = get_tid();
    qs.browser = E.get_browser(b);
    qs.id = opt.id;
    if (data_from_browser && data_from_browser.zon) qs.ver = data_from_browser.zon;else qs.ver = opt.ver || hopt.version;
    data.build = build_info(opt, ext);
    if (!opt.info || typeof opt.info != 'string') {
      opt.info = Object.assign(opt.info || {}, E._is_installed, qs_o.root_url ? {
        root_url: qs_o.root_url
      } : undefined);
    }
    if (!opt.info) opt.info = {};
    try {
      opt.info.ya_id = window.yaCounter81472444.getClientID();
    } catch (e) {}
    if (navigator && !navigator.cookieEnabled) opt.info.cookie_blocked = true;
    data.info = opt.info && typeof opt.info != 'string' ? JSON.stringify(opt.info) : opt.info;
    data.bt = opt.bt;
    data.filehead = opt.filehead;
    data.is_json = 1;
    var _perr_url = zutil.get(hopt, 'www_hola.perr_url', perr_url);
    if (hopt.www_hola.with_customerio) {
      try {
        window._cio.track(qs.id, opt.info);
      } catch (e) {}
    }
    return etask([function () {
      this.alarm(20000, {
        throw: new Error('timeout')
      });
      return $.ajax({
        type: 'POST',
        data: data,
        url: 'https://' + _perr_url + '/be_client_cgi/perr?' + zescape.qs(qs)
      });
    }]);
  };
  function perr_www_timing() {
    var id_to_track = [{
      id: 'util',
      test: /\/util\/util\.js|\/locale\/pub\/languages_ext.js/
    }, {
      id: 'affiliates',
      test: /\/scripts\/hwk0hjlkh$/
    }, {
      id: 'ga',
      test: /\/\/www\.google-analytics\.com\/analytics\.js/
    }];
    var types_to_track = [{
      type: 'js',
      test: /\.js($|\?.*)/
    }, {
      type: 'css',
      test: /\.css($|\?.*)/
    }, {
      type: 'cloudflare',
      test: /\.cloudflare\.com\//
    }, {
      type: 'cdn4',
      test: /cdn4\.hola\.org/
    }];
    var urls = performance.getEntries().map(function (entry) {
      var id_item = id_to_track.find(function (item) {
        return item.test.test(entry.name);
      });
      var types = types_to_track.filter(function (item) {
        return item.test.test(entry.name);
      }).map(function (item) {
        return item.type;
      });
      return {
        id: id_item && id_item.id,
        types: types,
        url: entry.name,
        ms: entry.duration,
        pathname: zurl.parse(entry.name).pathname
      };
    });
    E.perr({
      id: 'www_timing',
      info: {
        urls: urls.filter(function (entry) {
          return entry.id;
        }),
        types: urls.reduce(function (res, item) {
          item.types.forEach(function (type) {
            var v = res[type] || {};
            if (v.max || 0 < item.ms) {
              v.max = item.ms;
              v.item = item;
            }
            res[type] = v;
          });
          return res;
        }, {}),
        now: performance.now()
      }
    });
  }
  E.perr_www_visit = function (opt) {
    var visit_id = opt.id || 'www_untracked_visit';
    var ext_info = opt.ext_info || {};
    if (!ext_info.uuid) ext_info.uuid = qs_o.uuid;
    if (opt && opt.build) opt.build.has_ext = !!(ext_info && ext_info.uuid);
    E.perr({
      id: visit_id,
      info: {
        url: location.href,
        ref: qs_o.ref,
        referrer: document.referrer,
        aff_id: opt.aff_id,
        login: opt.user && opt.user.hola_uid,
        utm_source: qs_o.utm_source,
        utm_content: qs_o.utm_content,
        ext_info: zutil.pick(ext_info, 'uuid', 'ver', 'install_ts')
      },
      build: opt.build
    });
    if (E.utils_props.no_timing_perr) return;
    try {
      perr_www_timing();
    } catch (e) {
      E.perr({
        id: 'www_timing_error',
        info: {
          err: e
        }
      });
    }
  };
  E.perr_react = function (err, info) {
    var opt = {
      id: 'www_react_error',
      bt: err.stack,
      info: Object.assign({
        url: location.href
      }, info),
      build: {
        hola_uid: window.hola_user && window.hola_user.hola_uid
      }
    };
    E.perr(opt);
  };
  E.is_page_overriden = function (page, override) {
    if (hopt.www_hola && hopt.www_hola.pages_override) return hopt.www_hola.pages_override[page] == override;
    return false;
  };
  E.on_touch = function (element, callback) {
    var touch,
      threshold_px = 8,
      threshold_ms = 300;
    function on_touchstart(event) {
      var touches = event.originalEvent.targetTouches;
      if (touches.length != 1 || touch) return touch = undefined;
      touch = {
        id: touches[0].identifier,
        x: touches[0].clientX,
        y: touches[0].clientY,
        time: date()
      };
    }
    function on_touchend(event) {
      if (!touch) return;
      if (event.cancelable) event.preventDefault();
      var touches = event.originalEvent.changedTouches;
      if (touches.length == 1 && touches[0].identifier == touch.id && Math.abs(touches[0].clientX - touch.x) < threshold_px && Math.abs(touches[0].clientY - touch.y) < threshold_px && date() - touch.time < threshold_ms) {
        callback(event);
      }
      touch = undefined;
    }
    element.on('touchstart', on_touchstart);
    element.on('touchend', on_touchend);
    return function () {
      element.off('touchstart', on_touchstart);
      element.off('touchend', on_touchend);
    };
  };
  var join_sessions_etask;
  function join_sessions(user, info) {
    if (qs_o.debug_ui) console.log('Debug join_sessions start: ', user, info);
    E.session_sync_logs.push(`join_sessions ${user ? 'with_user' : 'no_user'}`);
    if (!user || user.disable_account_changes) return;
    // if login sync enabled, we prefer to join all sessions on the single PC,
    // so logout will impact all related browsers sessions
    return etask([function () {
      join_sessions_etask = this;
      return $.post('/users/auth/token/join?token=' + info.sync_token);
    }, function finally$() {
      if (qs_o.debug_ui) console.log('Debug join_sessions finish');
      E.session_sync_logs.push('join_sessions finish');
      join_sessions_etask = undefined;
    }]);
  }
  function update_pap_cookies(after_timeout) {
    if (hopt.login_as_user) return;
    if (!E.get_cookie_description().mark) return;
    var old_visitor_id = storage.get('pap_visitor_id') || undefined;
    var old_a_aid = storage.get('pap_a_aid') || undefined;
    var old_a_bid = storage.get('pap_a_bid') || undefined;
    var old_a_cid = storage.get('pap_a_cid') || undefined;
    storage.clr('pap_visitor_id');
    storage.clr('pap_a_aid');
    storage.clr('pap_a_bid');
    storage.clr('pap_a_cid');
    var visitor_id = cookie.get('PAPVisitorId') || storage.get('PAPVisitorId') || old_visitor_id;
    var a_aid = qs_o.a_aid || cookie.get('PAPAffiliateId') || old_a_aid;
    var a_bid = qs_o.a_bid || old_a_bid;
    var a_cid = qs_o.a_cid || old_a_cid;
    var exp = {
      day: 365
    };
    old_visitor_id = cookie.get('holapap_visitor_id');
    old_a_aid = cookie.get('hola_a_aid');
    old_a_bid = cookie.get('hola_a_bid');
    old_a_cid = cookie.get('hola_a_cid');
    var aff_subid = qs_o.aff_subid,
      aff_subid2 = qs_o.aff_subid2;
    var aff_subid3 = qs_o.aff_subid3;
    var old_aff_subid = cookie.get('holapap_aff_subid');
    var old_aff_subid2 = cookie.get('holapap_aff_subid2');
    var old_aff_subid3 = cookie.get('holapap_aff_subid3');
    var touched = false;
    if (visitor_id && old_visitor_id != visitor_id) {
      E.set_cookie('holapap_visitor_id', visitor_id, exp);
      touched = true;
    }
    if (a_aid) {
      var is_aid_changed = old_a_aid != a_aid;
      if (is_aid_changed) {
        E.set_cookie('hola_a_aid', a_aid, exp);
        touched = true;
      }
      if (old_a_bid != a_bid) {
        if (a_bid) E.set_cookie('hola_a_bid', a_bid, exp);else E.remove_cookie('hola_a_bid');
        touched = true;
      }
      if (old_a_cid != a_cid) {
        if (a_cid) E.set_cookie('hola_a_cid', a_cid, exp);else E.remove_cookie('hola_a_cid');
        touched = true;
      }
      if (is_aid_changed && old_aff_subid != aff_subid || !is_aid_changed && old_aff_subid != aff_subid && aff_subid) {
        if (aff_subid) E.set_cookie('holapap_aff_subid', aff_subid, exp);else E.remove_cookie('holapap_aff_subid');
        touched = true;
      }
      if (is_aid_changed && old_aff_subid2 != aff_subid2 || !is_aid_changed && old_aff_subid2 != aff_subid2 && aff_subid2) {
        if (aff_subid2) E.set_cookie('holapap_aff_subid2', aff_subid2, exp);else E.remove_cookie('holapap_aff_subid2');
        touched = true;
      }
      if (is_aid_changed && old_aff_subid3 != aff_subid3 || !is_aid_changed && old_aff_subid3 != aff_subid3 && aff_subid3) {
        if (aff_subid3) E.set_cookie('holapap_aff_subid3', aff_subid3, exp);else E.remove_cookie('holapap_aff_subid3');
        touched = true;
      }
    }
    if (!visitor_id) {
      // XXX dmitriiz: temp disable to reduce load
      if (after_timeout && 0) E.perr({
        id: 'www_pap_visitor_id_missed'
      });
      setTimeout(() => {
        update_pap_cookies(true);
      }, 3000);
    } else if (after_timeout) {
      E.perr({
        id: 'www_pap_visitor_id_after_timeout'
      });
      touched = true;
    }
    if (touched) {
      E.perr({
        id: 'www_pap_changed',
        info: {
          old: {
            aid: old_a_aid,
            bid: old_a_bid,
            cid: old_a_cid,
            visitor_id: old_visitor_id,
            aff_subid: old_aff_subid,
            aff_subid2: old_aff_subid2,
            aff_subid3: old_aff_subid3
          },
          'new': {
            aid: a_aid,
            bid: a_bid,
            cid: a_cid,
            visitor_id: visitor_id,
            aff_subid: aff_subid,
            aff_subid2: aff_subid2,
            aff_subid3: aff_subid3
          }
        }
      });
    }
  }
  function set_mkt_cookies(marketing_obj) {
    var cname = field => field == 'ref' ? 'orig_ref' : `hola_${field}`;
    var val = field => {
      if (field == 'referrer') return document.referrer;
      return (marketing_obj || {})[field] || qs_o[field];
    };
    var fields = ['gclid', 'gbraid', 'wbraid', 'gad_source', 'gad_campaignid', 'utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term', 'utm_match', 'a_aid', 'a_bid', 'a_cid', 'cio_medium', 'cio_source', 'cio_campaign', 'ref', 'referrer'];
    if (hopt.login_as_user) return void fields.forEach(f => E.remove_cookie(cname(f)));
    if (!E.get_cookie_description().mark) return;
    if (fields.map(f => cookie.get(cname(f)) || '').some(v => v)) return;
    fields.filter(val).forEach(f => E.set_cookie(cname(f), val(f), {
      day: 365
    }));
  }
  E.update_pap_cookies = update_pap_cookies;
  E.get_user_raw = function (opt) {
    opt = opt || {};
    return etask([function () {
      this.alarm(20000, {
        throw: new Error('timeout')
      });
      return $.get('/users/get_user?' + zescape.qs({
        source: opt.source || 'login',
        tz_offset: new Date().getTimezoneOffset()
      }));
    }, function (res) {
      if (res && res.user && res.user.displayName && res.user.displayName.familyName) {
        var emails = res.user.emails || [];
        var email = emails[0] && emails[0].value || '';
        var t_name = (res.user.name || '').trim();
        var d_name = t_name || email;
        var old_d_name = res.user.displayName;
        res.user.displayName = d_name;
        res.user.name = old_d_name;
      }
      return opt.raw && res || res && res.user || null;
    }]);
  };
  var get_user_etask, user_cache;
  var get_user_counter = 0;
  E.get_user = function (opt) {
    var current_counter = '(' + get_user_counter + ') ';
    get_user_counter = get_user_counter + 1;
    opt = Object.assign({
      raw: true
    }, opt);
    if (qs_o.debug_ui) console.log('Debug get_user: start', opt);
    E.session_sync_logs.push(current_counter + 'get_user');
    if (get_user_etask) return get_user_etask;
    if (opt.cache && user_cache) {
      if (qs_o.debug_ui) console.log('Debug get_user: return from cache', user_cache);
      E.session_sync_logs.push(current_counter + 'get_user return from cache');
      return user_cache;
    }
    var last_svc_info = null;
    return get_user_etask = etask([function () {
      return E.get_user_raw(opt);
    }, function (res) {
      if (qs_o.debug_ui) console.log('Debug get_user_raw: ', res);
      E.session_sync_logs.push(current_counter + `get_user_raw: ${res && res.user ? res.user._id : 'null'}`);
      user_cache = res = res || {};
      return app_checker.get_svc_info();
    }, function (info) {
      if (qs_o.debug_ui) console.log('Debug get_svc_info: ', info);
      E.session_sync_logs.push(current_counter + `get_svc_info from get_user ${info ? 'OK' : 'null'}`);
      E.session_sync_logs.push(current_counter + `sync token get_svc_info from get_user ${info ? info.sync_token : ''}`);
      if (info && info.sync_token) E.session_sync_logs.mark_as_positive_to_send = true;
      if (user_cache.user || opt.nosync) {
        if (info && info.sync_token && user_cache.user.sync_token != info.sync_token) {
          user_cache.user.sync_token = info.sync_token;
          join_sessions(user_cache.user, info);
        }
        return this.return(user_cache);
      }
      return info;
    }, function try_catch$(info) {
      info = info || {};
      if (!info.sync_token) {
        E.session_sync_logs.push(current_counter + `return user_cache where st = ${user_cache && user_cache.user && user_cache.user.sync_token}`);
        return this.return(user_cache);
      }
      // login sync attempt
      if (qs_o.debug_ui) console.log('Start user logging in with st: ', info.sync_token);
      E.session_sync_logs.push(current_counter + `login with sync token ${info.sync_token}`);
      last_svc_info = info;
      return $.post('/users/auth/token/login?token=' + info.sync_token);
    }, function () {
      if (this.error) return this.return(user_cache);
      return E.get_user_raw(opt);
    }, function (res) {
      user_cache = res || {};
      var user_st = user_cache && user_cache.user && user_cache.user.sync_token || '';
      E.session_sync_logs.push(current_counter + `after login with st, user_cache.user.sync_token = ` + user_st);
      if (user_cache.user || opt.nosync) {
        if (last_svc_info && last_svc_info.sync_token && user_cache.user.sync_token != last_svc_info.sync_token) {
          E.session_sync_logs.push(current_counter + `join session with st = ${last_svc_info.sync_token}`);
          user_cache.user.sync_token = last_svc_info.sync_token;
          join_sessions(user_cache.user, last_svc_info);
        }
        return this.return(user_cache);
      }
      return user_cache;
    }, function finally$() {
      get_user_etask = undefined;
    }]);
  };
  E.get_user_sync_token = function (hash) {
    E.session_sync_logs.push('call get_user_sync_token');
    return etask([function () {
      return join_sessions_etask;
    }, function try_catch$() {
      var hash_url = hash ? '?hash_code=' + hash : '';
      E.session_sync_logs.push('call token/generate');
      return $.get('/users/auth/token/generate' + hash_url);
    }, function (data) {
      E.session_sync_logs.push('has data in get_user_sync_token ' + data.token);
      return !this.error ? data.token : '';
    }]);
  };
  E.only_new_user_tests = ['test_email_checkout'];
  E.ignored_tests = ['test_refund_special_big_offer_vs_cta'];
  E.get_active_tests = function () {
    var tests = Object.keys(experiment_init.ui_test_conf);
    var b_ = user_agent.guess_browser();
    if (b_.opera) b_.browser = 'opera';
    var ext_version = data_from_browser.ext_version;
    try {
      ext_version = window.document.documentElement.getAttribute('hola_ext_version');
    } catch (e) {}
    var guess = guess_os_and_version();
    var qs = zurl.qs_parse_url(window.location.href, {
      safe: true
    });
    var checking_obj = Object.assign({
      pathname: window.location.pathname,
      search: window.location.search,
      search_full: zurl.qs_str(qs),
      os: guess.os,
      os_version: guess.version,
      os_and_version: `${guess.os}_${guess.version}`,
      browser: b_.browser,
      ext_version: ext_version || qs_o.ext_version,
      tests: experiment_init.ui_test
    }, E.initial_props);
    return tests.filter(t => {
      if (user_cache && user_cache.user && E.only_new_user_tests.includes(t)) return false;
      var test_conf = experiment_init.ui_test_conf[t];
      var test_enabled_value = typeof test_conf == 'object' ? test_conf.on : test_conf;
      if (checking_obj.tests[t] == null) return false;
      if (test_conf && test_conf.ssr && test_enabled_value > 0) return true;
      if (!experiment_init.check_is_active(checking_obj, test_conf)) return false;
      return !E.ignored_tests.includes(t) && test_enabled_value > 0 && test_enabled_value < 1;
    }).map(t => {
      var test_conf = experiment_init.ui_test_conf[t];
      var test_name = typeof test_conf == 'object' ? test_conf.name || t : t;
      return {
        id: test_name.replace(/^test_/, ''),
        value: experiment_init.ui_test[t],
        conf: test_conf
      };
    });
  };
  var get_mship_etask, mship_cache;
  E.get_membership = function (opt) {
    opt = opt || {};
    // XXX volodymyr: consider returning cached version by default, force
    // reload per option
    if (opt.cache && mship_cache !== undefined) return mship_cache;
    if (get_mship_etask) return get_mship_etask;
    return get_mship_etask = etask([function () {
      if (opt.nosync) return;
      return get_user_etask; // possible login sync, wait
    }, function () {
      return fetch(config.backend_url + '/users/payment/get_membership?ver=' + hopt.version);
    }, function (res) {
      return mship_cache = res;
    }, function finally$() {
      get_mship_etask = undefined;
    }]);
  };
  E.get_payment_history = function () {
    return fetch(config.backend_url + '/users/payment/get_payment_history?ver=' + hopt.version);
  };
  E.is_membership_active = function () {
    return etask([function () {
      return E.get_membership();
    }, function (m) {
      return m && membership.is_active(m);
    }]);
  };
  E.check_tags = function (prefix) {
    var id = '';
    if (!window.google_tag_manager) id += '_no_gtm';
    if (!(window.ga && window.ga.create)) id += '_no_ga';
    if (id) E.perr({
      id: prefix + id,
      info: {
        ppc_src: cookie.get('ppc') || ''
      }
    });
  };
  E.save_orig_ref = function () {
    if (!E.get_cookie_description().mark) return;
    var ref = qs_o.ref;
    if (!ref) return;
    cookie.set('orig_ref', ref, {
      domain: `.${location.host}`,
      path: '/',
      expires: date.add(date(), {
        day: 30
      })
    });
  };
  E.load_script = function (_url) {
    var script = document.createElement('script');
    script.async = true;
    script.src = _url;
    var other = document.getElementsByTagName('script')[0];
    other.parentNode.insertBefore(script, other);
    return script;
  };
  E.pass_err_short = 'Password must contain at least 8 characters';
  E.pass_err_weak = 'Password must contain: 8 characters minimum, at least one ' + 'number, at least one uppercase.';
  E.pass_err_stronger = 'Please choose a stronger password and try again';
  E.is_safe_redirect = function (url) {
    var bext_login = cookie.get('bext_login_origin');
    if (bext_login && window.URL) {
      var u;
      try {
        u = new window.URL(url);
      } catch (e) {}
      if (u && zurl.get_root_domain(u.hostname) == zurl.get_root_domain(bext_login)) {
        return url;
      }
    }
    return zurl.safe_redir(url, location.host);
  };
  E.safe_redirect = function (url) {
    var safe_url = zurl.safe_redir(url, location.host);
    if (!safe_url) return void E.perr({
      id: 'www_unsafe_redirect',
      info: {
        url: url
      }
    });
    location.href = safe_url;
  };
  E.get_click_data = function (element) {
    while (element && !['A', 'BUTTON'].includes(element.tagName)) element = element.parentElement;
    if (!element || !element.dataset) return {};
    var info;
    try {
      info = JSON.parse(element.dataset.info);
    } catch (e) {}
    return {
      id: element.dataset.clickid,
      info: info
    };
  };
  E.is_rtl = function (lng) {
    return /^(ar|he|fa|ur)$/.test(lng || navigator && navigator.language);
  };
  E.lng_dir = function (lng) {
    return E.is_rtl(lng) ? 'rtl' : 'ltr';
  };
  E.open_popup_cb = function (href, cb, on_close) {
    var screen_left = window.screenLeft || 0;
    var screen_top = window.screenTop || 0;
    var win_width = window.innerWidth;
    var win_height = window.innerHeight;
    var width = Math.min(580, win_width);
    var height = Math.min(640, win_height);
    var left = (win_width - width) / 2 + screen_left;
    var top = (win_height - height) / 2 + screen_top;
    var is_coop_site = ['toolip', 'oculus', 'browserai'].includes(E.site);
    if (is_coop_site) {
      document.cookie = 'oauth_popup=1; max-age=600; path=/';
      var channel = new window.BroadcastChannel('oauth_channel');
      channel.onmessage = e => {
        if (e.data == 'auth_done') {
          channel.close();
          location.href = decodeURIComponent(href.split('next=')[1]);
        }
      };
    }
    var popup = window.open(href, 'hola_popup_cp', `height=${height},width=${width},left=${left},top=${top}`);
    if (!popup) return;
    popup.focus();
    popup.hola_callback = cb;
    window.hola_callback = cb || true;
    if (!on_close) return popup;
    var popup_tick = setInterval(function () {
      if (!popup.closed) return;
      clearInterval(popup_tick);
      on_close();
    }, 500);
    return popup;
  };
  E.md5hola = function (pathname) {
    var md5qs = (config.url2md5(pathname).match(/\?.*/) || [])[0];
    // XXX dmitriyr/nikita: cdn should be used
    return md5qs ? pathname + md5qs : pathname;
  };
  E.after_apply_cookie = () => {
    set_mkt_cookies(E.marketing_obj);
    E.save_orig_ref();
  };
  E.deep_merge = (target, source) => {
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        var s_val = source[key];
        var t_val = target[key];
        if (zutil.is_object(s_val) && zutil.is_object(t_val)) target[key] = E.deep_merge(t_val, s_val);else target[key] = s_val;
      }
    }
    return target;
  };
  var fetch_ip_info = () => etask(function* () {
    if (hopt.login_as_user) return {};
    try {
      var url = '/users/ip_info' + (qs_o ? `?${new URLSearchParams(qs_o)}` : '');
      var res = yield fetch(url);
      if (!res) throw new Error('No response received from /ip_info');
      return res;
    } catch (e) {
      return {};
    }
  });
  E.init_with_marketing = (props, postpone_detection, utils_props, site = 'hola') => etask(function* () {
    var marketing = yield fetch_ip_info();
    E.marketing_obj = marketing;
    E.site = site;
    return E.init(props, postpone_detection, utils_props);
  });
  return E;
});